<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="data.title"
	[headerIcon]="{fontIcon: 'fa-pencil', fontSet: 'fa'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<mat-form-field color="accent">
			<mat-label [innerHTML]="data.description" />
			<input
				(keydown.enter)="close({action: 'ok', text: text})"
				[(ngModel)]="text"
				[attr.maxlength]="data.maxlength"
				[attr.pattern]="data.validationRegex"
				[attr.placeholder]="data.title"
				[attr.type]="data.textType"
				class="form-control"
				matInput
				style="margin-top: 10px"
			/>
			@if (data.maxlength) {
				<mat-hint
					[translateParams]="{characterlimit: data.maxlength}"
					[translate]="'PROMPT_DIALOG_MODAL_MODULES_NAMELIMIT'"
					class="creationhint"
				/>
			}
		</mat-form-field>
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="data.cancelText" [color]="'warn'" />
		<sim-button
			(onClick)="close({action: 'ok', text: text})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
